import React, { useState, useRef } from "react";
import IconButton from "@material-ui/core/IconButton";
import { withRouter } from "react-router-dom";
import Menu from "@material-ui/core/Menu";
import PersonIcon from "@material-ui/icons/Person";
import MenuItem from "@material-ui/core/MenuItem";
import CloseIcon from "@material-ui/icons/Close";
import {
  withStyles,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
} from "@material-ui/core";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import withContext from "../tools/withContext";

const styles = (theme: Theme) =>
  createStyles({
    button: {},
  });

const formatProfileName = (firstName?: string, lastName?: string) => {
  const name = [firstName, lastName].filter(Boolean).join(" ");
  if (!name) return "";
  return name.charAt(0).toUpperCase() + name.slice(1);
};

const Profil = (props: any) => {
  const {
    ctx: { user, appVersion, isAppVersionLoading },
    onLogout,
    history,
    buttonClassName,
    iconClassName,
    nameClassName,
    textBlockClassName,
    showRole = false,
    roleLabel,
    roleClassName,
  } = props;
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [aboutOpen, setAboutOpen] = useState(false);
  const profileButtonRef = useRef<HTMLElement>(null);
  const textBlockRef = useRef<HTMLDivElement>(null);

  const menuButtonClicked = (e: React.MouseEvent) => {
    e.stopPropagation();
    setAnchorEl(textBlockRef.current || profileButtonRef.current);
  };

  const closeMenu = () => setAnchorEl(null);

  const navigateToChangePwd = () => {
    const { pathname, search } = props.location;
    history.push(
      `/change-password?redirectPathname=${pathname}&redirectQuery=${search}`,
    );
    closeMenu();
  };

  const navigateToProfil = () => {
    history.push(`/users/${user.login}`);
    closeMenu();
  };

  const navigateToNotifications = () => {
    history.push(`/notifications`);
    closeMenu();
  };

  return (
    <React.Fragment>
      <IconButton
        buttonRef={profileButtonRef}
        onClick={menuButtonClicked}
        color="inherit"
        className={buttonClassName}
        style={buttonClassName ? undefined : { borderRadius: 4 }}
      >
        <PersonIcon
          fontSize={iconClassName ? "inherit" : "small"}
          className={iconClassName}
        />
        {user && (user.firstName || user.lastName) && (
          <div
            ref={textBlockRef}
            className={textBlockClassName}
            style={
              textBlockClassName
                ? undefined
                : { marginLeft: 6, lineHeight: 1.2, textAlign: "left" }
            }
          >
            <Typography
              variant="body2"
              component="span"
              className={nameClassName}
              style={
                nameClassName
                  ? undefined
                  : { color: "inherit", fontWeight: 500, display: "block" }
              }
            >
              {formatProfileName(user.firstName, user.lastName)}
            </Typography>
            {showRole && roleLabel && (
              <Typography
                variant="body2"
                component="span"
                className={roleClassName}
                style={
                  roleClassName
                    ? undefined
                    : {
                        display: "block",
                        color: "rgba(255, 255, 255, 0.75)",
                        fontSize: "0.6875rem",
                        fontWeight: 400,
                      }
                }
              >
                {roleLabel}
              </Typography>
            )}
          </div>
        )}
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorEl)}
        onClose={closeMenu}
        disableAutoFocusItem
        elevation={2}
        marginThreshold={8}
      >
        <MenuItem onClick={() => navigateToChangePwd()}>
          Changer de mot de passe
        </MenuItem>
        <MenuItem onClick={() => navigateToProfil()}>Mon profil</MenuItem>
        <MenuItem onClick={() => navigateToNotifications()}>
          Notifications
        </MenuItem>
        <MenuItem onClick={onLogout}>Déconnexion</MenuItem>
        <Divider style={{ backgroundColor: "#e0e0e0" }} />
        <MenuItem
          onClick={() => {
            closeMenu();
            setAboutOpen(true);
          }}
        >
          À propos
        </MenuItem>
      </Menu>
      <Dialog
        open={aboutOpen}
        onClose={() => setAboutOpen(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{ style: { minHeight: "400px" } }}
      >
        <div style={{ position: "relative" }}>
          <DialogTitle style={{ padding: "10px 16px" }}>Labeler</DialogTitle>
          <IconButton
            aria-label="fermer"
            onClick={() => setAboutOpen(false)}
            style={{ position: "absolute", right: 8, top: 6, padding: 4 }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
        <Divider style={{ backgroundColor: "#e0e0e0" }} />
        <DialogContent
          style={{
            flex: "1 1 auto",
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
        >
          <Typography variant="body1">
            Version :{" "}
            {isAppVersionLoading ? "Chargement..." : appVersion || "-"}
          </Typography>
        </DialogContent>
        <Divider style={{ backgroundColor: "#e0e0e0" }} />
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ padding: "4px 16px" }}
        >
          © 2026 Labeler. Tous droits réservés.
        </Typography>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(withContext(withRouter(Profil)));
